import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, map } from 'rxjs';

export class MultiHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private fileDirs: string[],
  ) {}

  getTranslation(lang: string): Observable<any> {
    const files = this.fileDirs.map((fp) => fp.concat(`/${lang}.json`));
    return forkJoin(files.map((path) => this.http.get<any>(path))).pipe(map((responseArr) => Object.assign({}, ...responseArr)));
  }
}

export function multiHttpLoaderFactory(http: HttpClient, fileDirs: string[]): TranslateLoader {
  return new MultiHttpLoader(http, fileDirs);
}
